export const ADD_CHECKOUT_PROCESS = "ADD_CHECKOUT_PROCESS";
export const ADD_CHECKOUT_SUCCESS = "ADD_CHECKOUT_SUCCESS";

export const REMOVE_CHECKOUT_PROCESS = "REMOVE_CHECKOUT_PROCESS";
export const REMOVE_CHECKOUT_SUCCESS = "REMOVE_CHECKOUT_SUCCESS";
